import { Stack, SxProps, Theme } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import Paper from '@mui/material/Paper';
import React, { useEffect, useState } from 'react';

import { LoaderStyle } from '@/components/loader/Loader.style.ts';
import { themeColors } from '@/config/theme/themeColors.ts';
import { getSx } from '@/utils/getSx.util.ts';

interface Props {
  fixed?: boolean;
  spinnerSx?: SxProps<Theme>;
  sx?: SxProps<Theme>;
}
export const Loader: React.FC<Props> = props => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setVisible(true);
    }, 300);

    return () => clearTimeout(timer);
  }, []);

  const MainLoader = (
    <Stack
      sx={getSx(
        { alignItems: 'center', height: '100%', justifyContent: 'center' },
        props.spinnerSx ?? {},
      )}
    >
      <CircularProgress sx={{ color: themeColors.darkBlue, my: 4 }} />
    </Stack>
  );

  if (visible) {
    return props.fixed ? (
      <Paper sx={getSx(LoaderStyle, props.sx ?? {})}>{MainLoader}</Paper>
    ) : (
      MainLoader
    );
  }

  return <></>;
};
